<template>
  <div>
    <!-- MODO “TELA NORMAL”: seleção de período + botão Executar -->
    <div v-if="!printMode">
      <h6>Registro de Quedas de Alunos</h6><p></p>
      <div class="row mb-3">
        <div class="col-auto">
          <label>Data Início:</label>
          <input
            type="date"
            v-model="dataInicioLocal"
            class="form-control"
          />
        </div>
        <div class="col-auto">
          <label>Data Fim:</label>
          <input
            type="date"
            v-model="dataFimLocal"
            class="form-control"
          />
        </div>
        <div class="col-auto align-self-end">
          <button @click="abrirPrint" class="btn btn-primary">
            Executar
          </button>
        </div>
      </div>
    </div>

    <!-- MODO “IMPRESSÃO/PRINT”: exibe tabela de quedas -->
    <div v-else>
      <p class="text-center" style="font-size: 14px;">
        ( {{ globalUtils.formatarData(dataInicio) }} a
        {{ globalUtils.formatarData(dataFim) }} )
      </p>

      <div v-if="loading">Carregando…</div>
      <div v-else>
        <div v-if="registros.length">
          <h6>Registro de Quedas</h6>
          <table class="table table-striped table-print">
            <colgroup>
              <col style="width: 18%;">
              <col style="width: 12%;">
              <col style="width: 10%;">
              <col style="width: 18%;">
              <col style="width: 12%;">
              <col style="width: 50%;">
            </colgroup>

            <thead>
              <tr>
                <th>Aluno(*)</th>
                <th>Data</th>
                <th>Animal</th>
                <th>Instrutor</th>
                <th>Severidade</th>
                <th>Relato</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(item, idx) in registros" :key="'queda-' + idx">

                <!-- Aluno -->
                <td
                  :data-contato-familia="item.contato_familia ? 'true' : 'false'"
                  :class="{ 'text-danger': !item.contato_familia, 'text-success': item.contato_familia }"
                >
                  {{ item.aluno }}
                </td>
                <td>{{ globalUtils.formatarData(item.data_queda) }}</td>
                <td>{{ item.animal || '—' }}</td>
                <td>{{ item.instrutor }}</td>

                <td>
                  <span :style="badgePrintStyle(item.severidade)">
                    {{ item.severidade }}
                  </span>
                </td>

                <td>{{ item.relato }}</td>

              </tr>
            </tbody>
          </table>
          <p style="font-style: italic;">(*) O nome do Aluno em vermelho indica que a família não foi avisada.</p>
        </div>
        <div v-else>
          <p class="text-muted">
            Nenhum registro de queda encontrado para este período.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import axios from '@/services/axios'
import globalUtils from '@/utils/globalUtils.js'

// Props vindas do ReportPrintWrapper
const props = defineProps({
  printMode:  { type: Boolean, default: false },
  dataInicio: String,
  dataFim:    String,
  printTitle: { type: String, default: 'Relatório' },
  subtitle:   { type: String, default: '' }
})

const router = useRouter()

// Estados para modo “tela normal”
const dataInicioLocal = ref('')
const dataFimLocal    = ref('')

// Estados para modo “print”
const loading   = ref(false)
const registros = ref([])

function badgePrintStyle(nivel) {
  switch (nivel) {
    case 'vermelho':
      return { background: '#dc3545', color: '#fff', padding: '2px 6px', borderRadius: '4px' }
    case 'amarelo':
      return { background: '#ffc107', color: '#000', padding: '2px 6px', borderRadius: '4px' }
    case 'roxo':
      return { background: '#6a1b9a', color: '#fff', padding: '2px 6px', borderRadius: '4px' }
    case 'verde':
      return { background: '#198754', color: '#fff', padding: '2px 6px', borderRadius: '4px' }
    default:
      return { background: '#6c757d', color: '#fff', padding: '2px 6px', borderRadius: '4px' }
  }
}

// Se estivermos em printMode, buscar os dados assim que montar
onMounted(async () => {
  if (!props.printMode) return
  if (!props.dataInicio || !props.dataFim) return

  loading.value = true
  try {
    const res = await axios.get(
      '/gestao/relatorios/operacionais/alunos-quedas',
      { params: { dataInicio: props.dataInicio, dataFim: props.dataFim } }
    )
    // Agora cada registro tem { aluno, data_queda, instrutor, relato, contato_familia }
    registros.value = Array.isArray(res.data.registros)
      ? res.data.registros
      : []
  } catch (e) {
    console.error('Erro ao buscar registros de quedas de alunos:', e)
    registros.value = []
  } finally {
    loading.value = false
  }
})

// Redireciona para o ReportPrintWrapper com as datas e subtitle
function abrirPrint() {
  if (!dataInicioLocal.value || !dataFimLocal.value) return

  const inicioFormatado = globalUtils.formatarData(dataInicioLocal.value)
  const fimFormatado    = globalUtils.formatarData(dataFimLocal.value)
  const subtitle        = `( ${inicioFormatado} a ${fimFormatado} )`

  router.push({
    path: `/gestao/relatorios/print/alunos-quedas`,
    query: {
      title:      'Registro de Quedas de Alunos',
      dataInicio: dataInicioLocal.value,
      dataFim:    dataFimLocal.value,
      subtitle:   subtitle
    }
  })
}
</script>

<style scoped>
.mb-3 {
  margin-bottom: 1rem;
}

.table-print {
  font-size: 12px;
  table-layout: fixed;
}

.table-print td,
.table-print th {
  word-wrap: break-word;
  white-space: normal;
}
.bg-roxo {
  background-color: #6a1b9a !important; /* mesmo roxo do protocolo */
}
</style>
